package com.yogaaicoach.pages.workout.data

interface MediaController {
    fun setVideoToSecond(second: Int)
    fun setAudioToSecond(second: Int)
    fun pauseVideo()
    fun pauseAudio()
    fun continueVideo()
    fun continueAudio()
    fun setVideoSpeed(speed: Float)
    fun setAudioSpeed(speed: Float)
}

class DefaultMediaController : MediaController {
    override fun setVideoToSecond(second: Int) = com.yogaaicoach.platform.setVideoToSecond(second)
    override fun setAudioToSecond(second: Int) = com.yogaaicoach.platform.setAudioToSecond(second)
    override fun pauseVideo() = com.yogaaicoach.platform.pauseVideo()
    override fun pauseAudio() = com.yogaaicoach.platform.pauseAudio()
    override fun continueVideo() = com.yogaaicoach.platform.continueVideo()
    override fun continueAudio() = com.yogaaicoach.platform.continueAudio()
    override fun setVideoSpeed(speed: Float) = com.yogaaicoach.platform.setVideoSpeed(speed)
    override fun setAudioSpeed(speed: Float) = com.yogaaicoach.platform.setAudioSpeed(speed)
}